export const NoticeType = {
  engage: 2,
  notEngage: 1,
};

export interface NoticeDataType {
  items: Array<NoticeItemType>;
  hasNextPage: boolean;
  hasPreviousPage: boolean;
  pageCount: number;
  pageNumber: number;
  totalCount: number;
}

export interface NoticeAttachment {
  type: string;
  url: string;
  externalLink: number;
  order: number;
  contactName: string;
  contactPhone: string;
  contactEmail: string;
  address: string;
  fileSize: string;
  fileName: string;
}

interface NoticeTagCategories {
  id: number;
  name: string;
}

interface NoticeSchoolGroups {
  name: string;
  yearGroups: number | string;
}

interface NoticeTags {
  color: string;
  id: number;
  name: string;
  tagCategoryId: number;
}

export interface NoticeItemType {
  attachments: Array<NoticeAttachment>;
  blocks: Array<string>;
  body: string;
  date: string;
  id: number;
  isAlert: boolean;
  name: string;
  order: number;
  schoolGroups: Array<NoticeSchoolGroups>;
  tagCategories: Array<NoticeTagCategories>;
  tagCategoryIds: Array<number>;
  tagIds: Array<number>;
  tags: Array<NoticeTags>;
  timeStamp: string;
  title: string;
  type: 1 | 0;
  staffEmail: string;
  staffName: string;
}
